/**
 * Stable CSS class names for E2E — LCW dashboard charts.
 */
export const LWD = {
    root: 'product-dashboard-chart',
    chart: 'product-dashboard-chart__chart',
} as const;

export const lwdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

